import createHistory from 'history/createHashHistory';

const myHistory = createHistory();

export default myHistory;



// WEBPACK FOOTER //
// ./src/config/history.js